// NOTE: For the PO progress bar Kristen is able to edit the status of any PO through out the full process.
// She can change from one status to another att any point of the procss.
// When trying to change the PO  status to Business Manager Approved there will be a 500 error
// IMPORTANT :
// since the backend is set to send an email to Madison Pini when a PO reaches BM approval
// therefore change the backend email address and then try.

import React, { useState } from "react";
import { getUserId, getUsersRoles } from "../../../Utils/helper";
import { apiBaseURL } from "../../../Utils/ProjectConstants";
import "./progressStyles.css";

const stepKeyPO = [
  { value: 0, text: "New Request" },
  { value: 1, text: "Supervisor Approved" },
  { value: 2, text: "Business Manager Approved" },
  { value: 3, text: "With Legal" },
  { value: 4, text: "PO Entered" },
  { value: 5, text: "PO Sent to Vendor" },
  { value: 7, text: "Cancelled" },
  { value: 8, text: "On Hold" },
  { value: 10, text: "Action Requested" },
  { value: 11, text: "Action Provided" },
];

const stepKeyOrders = [
  { value: 0, text: "New Order" },
  { value: 1, text: "Supervisor Approved" },
  { value: 2, text: "PCard Approved" },
  { value: 3, text: "On Hold" },
  { value: 4, text: "Assistance Requested" },
  { value: 5, text: "Assistance Approved" },
  { value: 6, text: "Orederd" },
  { value: 7, text: "Shipped" },
  { value: 8, text: "Out for Delivery" },
  { value: 9, text: "Delivered" },
  { value: 10, text: "Denied" },
  { value: 11, text: "Cancelled" },
  { value: 12, text: "Out of stock" },
  { value: 13, text: "Order Edited" },
];

const ProgressBar = ({ type, order, fetch, fetchSuccessful, mutate }) => {
  const status = type === "PO" ? order.poStatus : order.status;
  const [currentStep, setStep] = useState(status);
  //const isUserKristen = true;
  const isUserKristen = getUserId() === "d4ec0560-d7b0-4385-81a3-ef5ac53df4da";
  // const isSuperUser = getUserId() === "e7cd4256-04e4-4429-9449-ec89cd93ea3d"; // UNCOMMENT THIS LINE FOR TESTING IN DEV

  const userRole = getUsersRoles(),
    isCoordinator = userRole.includes("Coordinator");

  const createArray = (length) => [...Array(length)];

  // moved onNext here, because both places are using the same function
  const onNext = async (status) => {
    let body = {};
    let response = null;
    switch (type) {
      case "PO":
        body = {
          id: order.id,
          userId: order.requestor?.id,
          vendorName: order.vendorName,
          vendorContact: order.vendorContact,
          vendorEmail: order.vendorEmail,
          vendorAddress: order.vendorAddress,
          deadlineType: order.deadlineType,
          deadlineDate: order.deadlineDate,
          urgencyJustification: order.urgencyJustification,
          POAdditionalEmails: order.poAdditionalEmails,
          additionalInfo: order.additionalInfo,
          shippingLocationId: order.shippingLocation.id,
          shippingAttn: order.shippingAttn,
          provideShippingAccountOnPO: order.provideShippingAccountOnPO,
          purchaseType: order.purchaseType,
          isInstallationRequired: order.isInstallationRequired,
          installationRequirements: order.installationRequirements,
          billingCode: order.billingCode,
          otherBilling: order.otherBilling,
          poStatus: status,
        };

        if (body.poStatus === 1) {
          response = await fetch.post(
            `${apiBaseURL}/api/Approval/Approve/PurchaseOrder?purchaseOrderId=${body.id}`,
          );
        } else {
          response = await fetch.put(`${apiBaseURL}/api/PurchaseOrders`, body);
        }
        if (fetchSuccessful(response)) {
          setStep(status);
          mutate && mutate();
        }
        break;
      case "Order":
        body = {
          id: order.id,
          vendors: order.vendors,
          urgency: order.urgency,
          status: status,
        };

        if (body.status === 0) {
          response = await fetch.post(
            `${apiBaseURL}/api/Approval/Approve?orderId=${body.id}`,
          );
        } else {
          response = await fetch.put(`${apiBaseURL}/api/Orders`, body);
        }
        if (fetchSuccessful(response)) {
          setStep(status);
          mutate && mutate();
        }
        break;
      default:
        break;
    }
  };

  // Allows Kristen and the Coordinators to edit the progress bar
  function Step({ step, done, selected, currentStep }) {
    const madisonCanEdit =
      type === "PO" &&
      isCoordinator &&
      ((currentStep === 2 && step.value === 3) || // BM Approved -> With Legal
        (currentStep === 3 && step.value === 4) || // With Legal -> PO Entered
        step.value === 7); // Cancel request

    const validation =
      ((currentStep === 0 && step.value === 1) ||
        (type === "PO" && isUserKristen) ||
        // (type === "PO" && isSuperUser) || // UNCOMMENT THIS LINE FOR TESTING IN DEV
        madisonCanEdit) &&
      !selected;

    const onStepClick = () => {
      if (validation) {
        return onNext(step.value);
      }
      return null;
    };

    return (
      <div
        className={`step ${done ? "done" : ""} ${selected ? "current" : ""}`}
        onClick={onStepClick}
        style={{ padding: step.value > 6 ? "10px" : null }}
      >
        <span className={`${validation ? "progressButton" : null}`}>
          {step.text}
        </span>
      </div>
    );
  }

  function Steps({ current = 0 }) {
    const stepKey = type === "PO" ? stepKeyPO : stepKeyOrders;

    if (current === 11) {
      const previousHistory = order.history
        .filter((x) => x.status !== 10 && x.status !== 11)
        .at(-1);
      const previousStatus = previousHistory?.status;
      return createArray(6).map((n, i) => (
        <Step
          key={i}
          currentStep={previousStatus}
          done={previousStatus > i}
          selected={previousStatus === i}
          step={stepKey.find((x) => x.value === i)}
        />
      ));
    } else if (current > 6) {
      return (
        <Step
          key={0}
          done={true}
          selected={true}
          step={stepKey.find((x) => x.value === current)}
        />
      );
    }
    return createArray(6).map((n, i) => (
      <Step
        key={i}
        currentStep={currentStep}
        done={currentStep > i}
        selected={currentStep === i}
        step={stepKey.find((x) => x.value === i)}
      />
    ));
  }

  return (
    <>
      <div className="arrow-steps center clearfix">
        <Steps current={currentStep} />
      </div>
    </>
  );
};

export default ProgressBar;
